import { useMutation } from "@apollo/client/react";
import { FORCE_APPROVE_INVOICE } from "../../mutations/invoices/forceApproveInvoice";
import GET_CLIENT_INVOICES from "../../queries/invoices/getClientInvoices";
import GET_CLIENT_ASSESSMENT_INVOICES from "../../queries/invoices/getClientAssessmentInvoices";
import GET_INVOICE_ASSESSMENT_DETAILS from "../../queries/invoices/getInvoiceAssessmentDetails";

export const useForceApproveInvoice = ({
  onCompleted,
  onError,
}: {
  onCompleted: (result?: any) => void;
  onError: (e?: any) => void;
}) => {
  const [forceApproveInvoice, { data, loading, error }] = useMutation(
    FORCE_APPROVE_INVOICE,
    {
      onCompleted: onCompleted,
      onError: onError,
      refetchQueries: [
        GET_CLIENT_INVOICES,
        GET_CLIENT_ASSESSMENT_INVOICES,
        GET_INVOICE_ASSESSMENT_DETAILS,
      ],
      awaitRefetchQueries: true,
    },
  );

  return { forceApproveInvoice, data, loading, error };
};
